import { LINE, MANUFACTURER, COLLECTION, MATTRESS_COLLECTION, MATTRESS, CLASSNAMES } from '../constants/commons';
import { stringOccurrences } from './text';

/**
 * Remove trailing slash from URL path.
 * @param url
 */
/**
 *  Get product's base URL according to its classname.
 *
 * @param className Product's classname.
 * @returns Product's base URL.
 */

export function getNoTrailingSlashPath(path: string): string {
  const slashesCount = stringOccurrences(path, '/');
  if (slashesCount <= 1) return path;

  const lastSlashIndex = path.lastIndexOf('/');

  return path.slice(0, lastSlashIndex) + path.slice(lastSlashIndex + 1);
}

export const getProductBaseURL = (className: string): string => {
  if (![MANUFACTURER, LINE, COLLECTION, MATTRESS_COLLECTION, MATTRESS].includes(className)) {
    return '';
  }

  return className === MANUFACTURER ? '/mattresses/' : `/mattress-${CLASSNAMES[className as keyof typeof CLASSNAMES]}/`;
};
